
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ProfileForm } from "@/components/profiles/ProfileForm";
import { Profile } from "@/types/profile";
import { useProfiles } from "@/hooks/useProfiles";
import ErrorDisplay from "@/components/ErrorDisplay";

export default function EditProfilePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { profiles, loading, error, updateProfile } = useProfiles();
  const [profile, setProfile] = useState<Profile | undefined>(undefined);

  useEffect(() => {
    if (!loading && profiles.length > 0 && id) {
      const foundProfile = profiles.find(p => p.id === id);
      if (!foundProfile) {
        navigate("/profiles", { replace: true });
      } else {
        setProfile(foundProfile);
      }
    }
  }, [id, profiles, loading, navigate]);

  if (loading) {
    return (
      <div className="container mx-auto py-8 px-4">
        <div className="h-8 w-48 bg-gray-200 rounded animate-pulse mb-8"></div>
        <div className="border rounded-lg p-6 space-y-4">
          <div className="h-6 w-2/3 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-1/2 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto py-8 px-4">
        <ErrorDisplay error={error} />
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="container mx-auto py-8 px-4">
        <div className="text-center py-8">
          <h2 className="text-xl font-semibold">Profile not found</h2>
          <p className="mt-2">The requested profile could not be found.</p>
        </div>
      </div>
    );
  }

  const handleSave = (profileData: Partial<Profile>) => {
    if (id) {
      updateProfile(id, profileData);
    }
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <ProfileForm initialData={profile} isEdit={true} onSave={(data) => handleSave(data)} />
    </div>
  );
}
